export enum WhatsAppExtensionMessageDirection {
  Outgoing = 'OUTGOING',
  Incoming = 'INCOMING',
}

export enum WhatsAppExtensionMessageType {
  Message = 'Message',
  Status = 'Status',
}

export interface WhatsAppExtensionMessage {
  Type: WhatsAppExtensionMessageType;
  MessageId?: string;
  Message?: string;
  Chatid?: string;
  File?: unknown | null;
  Ack?: number;
  Datetime?: number; // Unix timestamp in milliseconds
  Date?: string; // ISO 8601 formatted date string
  Direction?: WhatsAppExtensionMessageDirection;
  SentById?: string;
  ChannelName?: string;
  ChannelId?: string;
  SentByNumber?: string;
  sentByUserId?: string;
  CreatedByUser?: string;
  senderName?: string;
  Unread?: number;
}

export interface WhatsAppExtensionMessageCollection {
  [id: string]: WhatsAppExtensionMessage[];
}

export const WHATSAPP_EXTENSION_MESSAGE_WEBHOOK_ENDPOINT = 'whatsapp-extension/message';
